const diamond = [
    {
        id: "gen22",
        mas: 2,
        fem: 2,
        fill: "#754fff",
        name: "Gender-blending person",
        binary: false,
        description: "Androgyne who is fully both a woman and a man.",
        d: "M348 191.507L499.507 40L651.014 191.507L499.507 343.014L348 191.507Z"   
    },
    {
        id: "gen21",
        mas: 2,
        fem: 1,
        fill: "#4e96f2",
        name: "Feminine man",
        binary: false,
        description: "Man with feminine qualities.",
        d: "M196.507 343.014L348.015 191.507L499.521 343.014L348.015 494.521L196.507 343.014Z" 
    },
    {
        id: "gen20",
        mas: 2,
        fem: 0,
        fill: "#27dde5",
        name: "Masculine man",
        binary: true,
        description: "Man who is masculine.",
        d: "M45 494.521L196.507 343.014L348.014 494.521L196.507 646.028L45 494.521Z"  
    },
    {
        id: "gen12",
        mas: 1,
        fem: 2,
        fill: "#af4eff",
        name: "Masculine woman",
        binary: false,
        description: "Woman with masculine qualities.",
        d: "M499.521 343.014L651.029 191.507L802.536 343.014L651.029 494.521L499.521 343.014Z" 
    },
    {
        id: "gen11",
        mas: 1,
        fem: 1,
        fill: "#ae9cf4",
        name: "Androgyne",
        binary: false,
        description: "Person combining feminine and masculine aspects.",
        d: "M348.012 494.521L499.519 343.014L651.026 494.521L499.519 646.029L348.012 494.521Z" 
    },
    {
        id: "gen10",
        mas: 1,
        fem: 0,
        fill: "#87e2e7",
        name: "Demiman",
        binary: false,
        description: "Person with masculine qualities.",
        d: "M196.508 646.029L348.015 494.521L499.521 646.029L348.015 797.536L196.508 646.029Z" 
    },
    {
        id: "gen02",
        mas: 0,
        fem: 2,
        fill: "#e94dff",
        name: "Feminine woman",
        binary: true,
        description: "Woman who is feminine.",
        d: "M651.189 494.521L802.696 343.014L954.203 494.521L802.696 646.028L651.189 494.521Z"
    },
    {
        id: "gen01",
        mas: 0,
        fem: 1,
        fill: "#e89bf4",
        name: "Demiwoman",
        binary: false,
        description: "Person with feminine qualities.",
        d: "M499.521 646.029L651.029 494.521L802.536 646.029L651.029 797.536L499.521 646.029Z" 
    },
    {
        id: "gen00",
        mas: 0,
        fem: 0,
        fill: "#e7e8e9",
        name: "Agender person",
        binary: false,
        description: "Person with no feminine or masculine qualities.",
        d: "M348.012 797.536L499.519 646.029L651.026 797.536L499.519 949.043L348.012 797.536Z"
    },
];

export default diamond;